import axios from 'axios';

const BASE = '/ventas/ordenes';

export default {
  index(params = {}) {
    const { page = 1, rowsPerPage = 15, estado = null, q = null } = params;
    let url = `${BASE}?page=${page}&page_size=${rowsPerPage}`;
    if (estado) url += `&estado=${encodeURIComponent(estado)}`;
    if (q) url += `&q=${encodeURIComponent(q)}`;
    return axios.get(url);
  },

  show(id) {
    return axios.get(`${BASE}/${id}`);
  },

  create(data) {
    return axios.post(BASE, data);
  },

  update(id, data) {
    return axios.put(`${BASE}/${id}`, data);
  },

  cambiarEstado(id, estado) {
    return axios.post(`${BASE}/${id}/estado/${estado}`);
  },

  etiqueta(id) {
    return axios.get(`${BASE}/${id}/etiqueta`, { responseType: 'blob' });
  },
  etiquetasBultos(id) {
    return axios.get(`${BASE}/${id}/etiquetas-bultos`, { responseType: 'blob' });
  },
  ordenesProduccion(id) {
    return axios.get(`${BASE}/${id}/ordenes-produccion`);
  },
};
